import {copyObject} from "../../Util/functions";

export function createSvgEl<K extends keyof SVGElementTagNameMap>(type: K, attr): SVGElementTagNameMap[K] {
    let el = document.createElementNS("http://www.w3.org/2000/svg", type);

    if (attr) {
        Object.keys(attr).forEach(function(key) {
            const value = attr[key];
            if (key != key.toLowerCase() && ['viewBox', 'lengthAdjust', 'textLength'].indexOf(key) === -1) {
                key = key.replace(/[A-Z]/g, m => "-" + m.toLowerCase());
            }
            el.setAttributeNS(null, key, value);
        });
    }
    return el;
}

export function arrowSvg(
    x1: number,
    y1: number,
    x2: number,
    y2: number,
    headAttr: Record<string, any>,
    headDeg: number = 15,
    headFrac: number = 0.1,
): SVGGElement {
    const angle = Math.atan2(y2 - y1, x2 - x1);
    const length = Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);

    const group = createSvgEl('g', {});

    group.appendChild(createSvgEl('line', {
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2,
        stroke: '#000000',
        strokeWidth: 0.005,
    }));

    group.appendChild(createSvgEl('polyline', copyObject({
        points: [
            (x2 - Math.cos(angle - headDeg / 180 * Math.PI) * headFrac * length) + ',' + (y2 - Math.sin(angle - headDeg / 180 * Math.PI) * headFrac * length),
            x2 + ',' + y2,
            (x2 - Math.cos(angle + headDeg / 180 * Math.PI) * headFrac * length) + ',' + (y2 - Math.sin(angle + headDeg / 180 * Math.PI) * headFrac * length)
        ].join(' '),
        stroke: '#000000',
        fill: 'none',
        strokeWidth: 0.5,
    }, headAttr)));

    return group;
}

export function starSvg(
    x: number,
    y: number,
    rotationDeg: number|'extrapolate',
    r1: number,
    r2: number,
): SVGGElement {
    if (rotationDeg === 'extrapolate') {
        rotationDeg = Math.atan2(y, x) / Math.PI * 180;
    }

    const group = createSvgEl('g', {});

    const points = [];

    const steps = 10;
    for (let i = 0; i < steps; i++) {
        points.push([
            x + (i % 2 === 1 ? r2 : r1) * Math.cos((rotationDeg + i / steps * 360.) / 180. * Math.PI),
            y + (i % 2 === 1 ? r2 : r1) * Math.sin((rotationDeg + i / steps * 360.) / 180. * Math.PI),
        ]);
    }

    group.appendChild(createSvgEl('polygon', {
        points: points.map(xy => xy[0] + ',' + xy[1]).join(' '),
        stroke: 'none',
        fill: '#000000',
    }));

    return group;
}
